import { render, staticRenderFns } from "./duoTrainingModulePageMobile.vue?vue&type=template&id=785c4f45&"
import script from "./duoTrainingModulePageMobile.vue?vue&type=script&lang=js&"
export * from "./duoTrainingModulePageMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports